/* A LEAVER'S LAST DAY -- ONE OWNER (10-09 queue (c), 2026-10-09).

   The last day an employee worked is the STORED employees.end_date. It is never inferred from the salary series.

   WHY: the Payroll page used to set a leaver's termination date to the LAST DAY OF THE LAST PAID MONTH whenever the
   stored series stopped before the end of the window, in place of the stored end_date. The Edit dialog's Save then
   re-derived the series from that date and wrote it back as end_date -- re-paying the rest of the termination month
   (semi-monthly, 100,000 salary, last day 2026-10-20: +2,796.80), and a month late under bi-weekly "expensed when paid"
   (the last PAID month is the final check's month: +11,263.73). Measured in diffs/biweekly-4-build.txt; fixed in
   diffs/termdate-build.txt.

   THE ONE CASE WITH NO ANSWER: a series that stops paying before the window's end while no end_date is stored. The row
   says nothing about the last day, so it is NOT guessed (CLAUDE.md section E1) -- a caller refuses to rebuild that
   employee's series until a termination date is entered. The onboarding wizard's "Edit roster" refused exactly this
   case already (AdminPage Step 5); it now asks this owner. Measured 2026-10-09: 0 such employees on the five tenants.

   NOT YET ON THIS OWNER (filed): ModelProvider and RevenueBuildPage still infer "<last paid month>-28" for the
   engine's month gating. For a semi-monthly or bi-weekly-accrues company that month IS the end_date's month; for a
   bi-weekly company that expenses payroll when paid it is the final check's month, one month later.

   Plain ASCII on purpose (CLAUDE.md 12.5 rule 55). PURE. */

// The stored last day, as 'YYYY-MM-DD', or null when none is stored. Accepts the API's ISO string (or a date-only one).
export function storedLastDay(endDate) {
  if (endDate === null || endDate === undefined || endDate === '') return null;
  const d = String(endDate).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : null;
}

// The last month in `months` (ascending 'YYYY-MM') whose stored salary is > 0, or null.
export function lastPaidMonth(monthlyData, months) {
  let last = null;
  for (const m of months || []) if ((Number((monthlyData || {})[m]) || 0) > 0) last = m;
  return last;
}

// THE CASE WITH NO ANSWER: the series stops paying before the window's last month and no end_date is stored. Returns the
// last paid month ('YYYY-MM') -- for the refusal's words -- or null when the case does not apply.
export function paidThroughWithoutLastDay(endDate, monthlyData, months) {
  if (storedLastDay(endDate)) return null;
  const ms = months || [];
  const last = lastPaidMonth(monthlyData, ms);
  return last && ms.length && last < ms[ms.length - 1] ? last : null;
}
